import { render } from "./CommonFormInfoStatic.vue?vue&type=template&id=011973b6"
import script from "./CommonFormInfoStatic.vue?vue&type=script&lang=js"
export * from "./CommonFormInfoStatic.vue?vue&type=script&lang=js"

import "./CommonFormInfoStatic.vue?vue&type=style&index=0&id=011973b6&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__